import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen, Plus, Search } from "lucide-react";
import { api } from "../utils/api";
import { useAuth } from "../contexts/AuthContext";

const CATEGORIES = ["SAP", "Other Applications", "Hardware Support", "Software Support", "Network & Infrastructure", "IT Security", "Access Management", "How-to", "FAQ"];

export default function KnowledgeBase() {
  const { hasRole } = useAuth();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("");
  const isAuthor = hasRole("admin", "it_team", "it_manager", "it_security");

  async function load() {
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    if (cat) params.set("category", cat);
    const { data } = await api.get(`/api/kb/articles?${params.toString()}`);
    setItems(data);
  }
  useEffect(() => { load(); }, []); // eslint-disable-line
  useEffect(() => {
    const t = setTimeout(load, 250);
    return () => clearTimeout(t);
  }, [q, cat]); // eslint-disable-line

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <BookOpen className="text-brand-500" />
          <h1 className="text-2xl font-bold">Knowledge Base</h1>
        </div>
        {isAuthor && (
          <Link to="/knowledge-base/new" className="btn-primary flex items-center gap-2">
            <Plus size={16} /> New Article
          </Link>
        )}
      </div>

      <div className="card p-3 flex items-center gap-3">
        <Search size={16} className="text-gray-400" />
        <input className="flex-1 outline-none text-sm" placeholder="Search articles…" value={q} onChange={(e) => setQ(e.target.value)} />
        <select className="text-sm border-0 bg-transparent focus:outline-none" value={cat} onChange={(e) => setCat(e.target.value)}>
          <option value="">All categories</option>
          {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {items.length === 0 && <div className="card p-6 text-center text-gray-500">No articles match. Try a broader search.</div>}
        {items.map((a) => (
          <Link key={a.id} to={`/knowledge-base/${a.id}`} className="card p-4 hover:shadow-md transition">
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="text-xs text-gray-500">{a.category}</div>
                <h3 className="font-semibold mt-0.5">{a.title}</h3>
                <p className="text-sm text-gray-600 mt-1 line-clamp-2">{a.content.replace(/[#*`>]/g, "").slice(0, 160)}…</p>
                <div className="text-xs text-gray-400 mt-2">By {a.author_name} · {a.views} views</div>
              </div>
              {a.status !== "published" && <span className="badge bg-gray-100 text-gray-700">{a.status}</span>}
            </div>
            {a.tags?.length > 0 && (
              <div className="mt-2 flex flex-wrap gap-1">
                {a.tags.map((t) => <span key={t} className="badge bg-brand-50 text-brand-700">{t}</span>)}
              </div>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
}
